module.exports = __webpack_public_path__ + "img/tool_icon4.851dcfe6.svg";